import { queryClient } from '@shared/libs/react-query';
import { useMutation } from 'react-query';
import { createRoleByCase } from 'services/ClaimscoreApiService/Permissions';
import type {
  CreateCaseRolePayload,
  CreateCaseRoleResponse,
} from 'services/ClaimscoreApiService/Permissions/types';

const MUTATION_KEY = 'createUserCaseRole';

export const useCreateUserCaseRole = () =>
  useMutation<CreateCaseRoleResponse, Error, CreateCaseRolePayload>(
    MUTATION_KEY,
    ({ caseId, targetUsers }: CreateCaseRolePayload) =>
      createRoleByCase({
        caseId,
        targetUsers,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('getCaseAccounts');
      },
    },
  );
